import { render } from "./XCerrarModal.vue?vue&type=template&id=37da052b&scoped=true"
import script from "./XCerrarModal.vue?vue&type=script&lang=js"
export * from "./XCerrarModal.vue?vue&type=script&lang=js"

import "./XCerrarModal.vue?vue&type=style&index=0&id=37da052b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37da052b"

export default script